// extracted by mini-css-extract-plugin
module.exports = {"message":"ReactPlayerStrict_message__1FGVg","message__inner":"ReactPlayerStrict_message__inner__eHzF7"};